/* global window */

import Vue from 'vue';
import $ from 'jquery';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import axios from "axios";

import { RestComponent } from '../mixins/rest-component';
import { triggerEvent } from '../../scripts/tag-manager';

import './FilterOverview.scss';
import template from './FilterOverview.vhtml';

export default {
	name: 'FilterOverview',
	template: template,
	mixins: [
		RestComponent,
	],
	props: {
		endpoint: {
			type: String,
		},
		amount: {
			type: Number,
			default: -1,
		},
		hasFetchMore: {
			type: Boolean,
			default: false,
		},
		showNoneGrouped: {
			type: Boolean,
			default: false,
		},
		hasHighlightedArticles: {
			type: Boolean,
			default: false,
		},
		filters: {
			type: Array,
			default: () => [],
		},
		search: {
			type: String,
			default: '',
		},
		category: {
			type: [Number, String],
			default: '',
		},
	},
	data: () => ({
		results: [],
		groups: [],
		isLoading: false,
		isFetching: false,
		showMore: false,
		params: () => ({
			page: 1,
		}),
	}),
	computed: {
		showFetchMore: vm => vm.hasFetchMore && vm.showMore,
		listedResults: vm => vm.hasHighlightedArticles ? vm.results.slice(3) : vm.results
	},
	watch: {
		search(val) {
			Vue.set(this.params, 'search_str', val);
			this.reload();
		},
		category(val) {
			val === 'all' ? Vue.set(this.params, 'category', '') : Vue.set(this.params, 'category', val);
			this.reload();
		},
	},
	methods: {
		setupBgi: img => `url(${img})`,
		addItems(results, overwrite = false) {
			const items = results
			if (overwrite) {
				this.results = items;
			} else {
				console.log(this.results)
				console.log(items)
				console.log(this.results.concat(items))
				this.results = this.results.concat(items)
			}
		},
		getItems(endpoint, params) {
			return axios.get(endpoint, { params: this.params });
		},
		fetchMore: debounce(function () {
			this.params.page++;

			this.isFetching = true;
			this.getItems(this.endpoint, this.params)
				.then(response => {
					let result = response.data
					if (typeof response != 'object') {
						result = JSON.parse(response)
					}
					this.addItems(get(result, 'data', []), false);
					this.groups = this.groups.concat(get(result, 'groups', []).filter((item) => this.groups.indexOf(item) < 0));
					this.isFetching = false;
					let totalPages = result['maxPages'];
					let currentPage = this.params.page
					this.showMore = (currentPage < totalPages);
				});
		}, 500),
		reload: debounce(function () {
			this.params.page = 1;
			this.isLoading = true;

			this.getItems(this.endpoint, this.params)
				.then(response => {
					let result = response.data
					if (typeof response != 'object') {
						result = JSON.parse(response)
					}
					this.addItems(get(result, 'data', []), true);
					this.groups = get(result, 'groups', []);
					this.isLoading = false;
					let totalPages = result['maxPages'];
					let currentPage = this.params.page
					this.showMore = (currentPage < totalPages);
				})
		}, 500),
	},
	mounted() {
		const params = this.getAllUrlParams();
		this.params = { ...this.params, ...params };
		if (this.amount !== -1) Vue.set(this.params, 'per_page', this.amount + 1);
		Vue.set(this.params, 'includes', this.includes);
		Vue.set(this.params, 'lang', window.siteData.language);
		Vue.set(this.params, 'search_str', this.search);

		if (this.filters.length > 0) {
			this.search = params.search_str;
		}

		this.reload();
	}
};

/**
 * Gets resumes from WP REST API
 *
 * @param {string} post_type
 * @param {string} [search=""]
 * @returns {JQueryPromise<any>}
 */
// function getItems(endpoint, params) {
// 	return $.get(endpoint, params);
// }

function trackSearch(filters) {
	const search = filters.search_str;
	triggerEvent('searchRetailers', { retailerArea: search });
}
